import React, { useState, useEffect } from "react";

import ReactPaginate from "react-paginate";
import { Button, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { EventContractService } from "../../../services";
import html2pdf from "html2pdf.js";
import { Modal } from "react-bootstrap";
import { handleConsoleError } from "../../../utils/common-methods";
import { toast } from "react-toastify";

const EventContract = (props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  const navigate = useNavigate();
  const { eventId } = useParams();

  const [showModal, setShowModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getData(eventId);
  }, []);

  // Event Contract List
  const getData = async (eventId) => {
    props.application.setLoading(true);
    try {
      const res = await EventContractService.getEventContractByEventId(eventId);
      if (res?.isSuccess && res?.data.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      EventContractService.setContractId(id);
      navigate(routes.Event_EDIT_CONTRACT.replace(":eventId", eventId));
    } catch (error) {}
  };

  // Handle Import
  const HandleImport = async (value, EventId) => {
     props.application.setLoading(true);
    if (value === "Final Email Retailers") {
      getEventContractFinalEmailAdd(EventId, "FinalEmailRetailers");
    } else if (value === "Final Email Caterers") {
      getEventContractFinalEmailAdd(EventId, "FinalEmailCaterers");
    } else if (value === "Terms & Condition Retailers") {
      getEventContractTermAndConditionAdd(
        EventId,
        "TermsAndConditionRetailers"
      );
    } else if (value === "Terms & Condition Caterers") {
      getEventContractTermAndConditionAdd(EventId, "TermsAndConditionCaterers");
    } else if (value === "HandBook Retailers") {
      getEventContractHandBooks(EventId, "HandbookRetailers");
    } else if (value === "HandBook Caterers") {
      getEventContractHandBooks(EventId, "HandbookCaterers");
    }
     props.application.setLoading(false);
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  const getEventContractFinalEmailAdd = async (EventId, ContractType) => {
    try {
      const res =
        (EventId &&
          (await EventContractService.getEventContractFinalEmailAdd(
            EventId,
            ContractType
          ))) ||
        [];
      getData(EventId);
    } catch (error) {
    const message=  handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getEventContractTermAndConditionAdd = async (EventId, ContractType) => {
    try {
      const res =
        (EventId &&
          (await EventContractService.getEventContractTermAndConditionAdd(
            EventId,
            ContractType
          ))) ||
        [];
      getData(EventId);
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getEventContractHandBooks = async (EventId, ContractType) => {
    try {
      const res =
        (EventId &&
          (await EventContractService.getEventContractHandBooks(
            EventId,
            ContractType
          ))) ||
        [];
      getData(EventId);
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const HandleDownload = (contractId) => {
     props.application.setLoading(true);
    // Find the contract detail by ID
    const contract = paginatedData.find((item) => item.id === contractId);
    if (!contract || !contract.contractDtl) {
      alert("Contract details not found!");
      return;
    }
    const contractName = contract?.contractName?.replace(/\s+/g, "_");
    // Create a dynamic HTML content
    // const content = `
    //   <div style="padding: 20px; font-family: Arial, sans-serif;">
    //     <h2 style="text-align: center;">Contract Details</h2>
    //     <p><strong>Contract Name:</strong> ${contract.contractName}</p>
    //     <p>${contract.contractDtl.replace(/\n/g, "<br>")}</p>
    //   </div>
    // `;

    const content = `<div style="padding: 20px;">
        ${contract?.contractDtl}  <!-- 🟢 Yeh content proper format me hoga -->
      </div>`;
    const opt = {
      margin: [20, 20, 20, 20],
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      filename: `${contractName}.pdf`,
      image: { type: "jpeg", quality: 0.2 },
      html2canvas: {
        dpi: 50,
        scale: 3,
        letterRendering: true,
        useCORS: true,
        // scrollY: 2,
      },
      jsPDF: {
        unit: "pt",
        format: "a4",
        orientation: "portrait",
        putTotalPages: true,
        before: ".nextpage1",
        compress: true,
      },
      html2pdf: {
        jsPDF: { orientation: "portrait" },
        pagebreak: { mode: ["avoid-all"] },
      },
    };
    // Convert HTML to PDF
    html2pdf()
      .from(content)
      .set(opt)
      .save();

       props.application.setLoading(false);
  };

  // Open modal and set selected contract
  const handleOpenModal = (contractName) => {
    setSelectedContract(contractName);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContract(null);
  };

  // Confirm Import
  const handleConfirmImport = () => {
    if (selectedContract) {
      HandleImport(selectedContract, eventId);
    }
    handleCloseModal();
  };

  return (
    <React.Fragment>
      <section className="subscription-banner p-0">
        <div className="container">
          <h3>
            Use Our Fully Editable Trader Contracts & Communication
            Documentation Templates For Free!
            <p className="sub-heading-text">
              (Which are automatically sent to a trader once an application has
              been accepted by you)
            </p>
          </h3>
        </div>
      </section>
      <section className="edit-form-table">
        <div className="container">
          <div className="verifier-buttton"></div>

          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Contract Name</th>
                  <th>Event Name</th>
                  {/* <th>Contract Details</th> */}
                  <th>Contract For</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>{item?.contractName}</td>
                          <td>{item?.eventName}</td>
                          {/* <td>{item.contractDtl}</td> */}
                          <td>
                            {item?.contractFor === "C"
                              ? "Caterers"
                              : item?.contractFor === "R"
                              ? "Retail Trade Stands"
                              : "-"}
                          </td>
                          <td>
                            {item?.isActive === true ? (
                              <i className="ri-check-fill"></i>
                            ) : (
                              <i className="ri-close-circle-line"></i>
                            )}
                          </td>
                          <td>
                            <div className="delete-create">
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEdit(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                                title="Edit"
                              >
                                <i className="ri-pencil-line"></i>
                              </Link>
                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleOpenModal(item?.contractName); // Open modal for confirmation
                                }}
                                style={{ marginRight: "10px" }}
                                title="Import latest version from admin"
                              >
                                <i className="fa-solid fa-file-import"></i>
                              </Link>

                              <Link
                                onClick={(e) => {
                                  e.preventDefault();
                                  HandleDownload(item?.id);
                                }}
                                style={{ marginRight: "10px" }}
                                title="Download"
                              >
                                <i
                                  className="fa fa-download"
                                  aria-hidden="true"
                                ></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <Modal show={showModal} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Import</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to import <b>{selectedContract}</b>?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleConfirmImport}>
                Confirm
              </Button>
            </Modal.Footer>
          </Modal>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData?.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventContract);
